import { Button } from '@repo/foundations';
import { useCallback, useState } from 'react';
import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';

/**
 * Button component that appears when a frontend update is available
 * Only renders when there's an update pending
 */
function UpdateAvailableButton() {
	const { needRefresh, updateServiceWorker } = useServiceWorkerUpdate();
	const [isUpdating, setIsUpdating] = useState(false);

	const handleUpdate = useCallback(async () => {
		setIsUpdating(true);
		try {
			await updateServiceWorker();
		} catch {
			window.location.reload();
		} finally {
			setIsUpdating(false);
		}
	}, [updateServiceWorker]);

	// Only render the button if an update is available
	if (!needRefresh) {
		return null;
	}

	return (
		<Button
			variant="primary"
			onClick={handleUpdate}
			disabled={isUpdating}
			loading={isUpdating}
		>
			{isUpdating ? 'Updating...' : 'Update'}
		</Button>
	);
}

export default UpdateAvailableButton;
